import React from 'react';
import { Outlet } from 'react-router-dom';

import { ConnectionStatus } from './ConnectionStatus/ConnectionStatus';
import { MobileLayoutRoot, MobileContent } from './MobileLayout.styles';

export const MobileLayout: React.FC = () => {
  return (
    <MobileLayoutRoot>
      <ConnectionStatus />
      <MobileContent>
        <Outlet />
      </MobileContent>
    </MobileLayoutRoot>
  );
};
